export default __webpack_public_path__ + "images/9ce88729423c1fe06c951e9f8924cda1-christmas.webp";